import Aos from 'aos';

Aos.init({
    once: true,
});
